import { Action, createReducer, on } from '@ngrx/store';
import { FilterInterface, Tags } from '../../interfaces/filter.interface';
import {
  CollectFilters,
  ResetFilters,
  SelectBrand,
  SelectColors,
  SelectMaterial,
  SelectProductCategories,
  SelectProductSections,
  SelectShapes,
  SelectStyle,
  SetDiameterRange,
  SetPriceRange,
  SetVolumeRange,
} from '../actions/filter.actions';

const filter: FilterInterface = {
  tags: {
    productSections: {},
    productCategories: {},
    colors: {},
    shape: {},
    materials: {},
    styles: {},
    brands: {},
    priceRange: {},
    volumeRange: {},
    diameterRange: {},
  },
  activeFilterCollection: {
    colors: [],
    shape: [],
    categories: [],
    material: '',
    style: '',
    brand: '',
    sections: [],
  },
};
export const defaultFilter = filter;

const reducer = createReducer(
  filter,
  on(SelectProductSections, (state, value) => ({
    ...state,
    tags: {
      ...state.tags,
      productSections: value,
    },
  })),
  on(SelectProductCategories, (state, value) => ({
    ...state,
    tags: {
      ...state.tags,
      productCategories: value,
    },
  })),
  on(SelectColors, (state, value) => ({
    ...state,
    tags: {
      ...state.tags,
      colors: value,
    },
  })),
  on(SelectShapes, (state, value) => ({
    ...state,
    tags: {
      ...state.tags,
      shape: value,
    },
  })),
  on(SelectMaterial, (state, value) => ({
    ...state,
    tags: {
      ...state.tags,
      materials: value,
    },
  })),
  on(SelectBrand, (state, value) => ({
    ...state,
    tags: {
      ...state.tags,
      brands: value,
    },
  })),
  on(SelectStyle, (state, value) => ({
    ...state,
    tags: {
      ...state.tags,
      styles: value,
    },
  })),
  on(SetPriceRange, (state, value) => ({
    ...state,
    tags: {
      ...state.tags,
      priceRange: value,
    },
  })),
  on(SetVolumeRange, (state, value) => ({
    ...state,
    tags: {
      ...state.tags,
      volumeRange: value,
    },
  })),
  on(SetDiameterRange, (state, value) => ({
    ...state,
    tags: {
      ...state.tags,
      diameterRange: value,
    },
  })),
  on(CollectFilters, (state, value) => ({
    ...state,
    activeFilterCollection: value,
  })),
  on(ResetFilters, () => filter)
);

export const FilterReducer = (state: any, action: Action) =>
  reducer(state, action);
